export enum RequestedOS {
  LINUX = 'LINUX',
  WINDOWS = 'WINDOWS',
  MACOS = 'MACOS',
  TO_BE_DEFINED = 'TO_BE_DEFINED',
  ANY_OS = 'ANY_OS',
}

export enum RequestedOSLabel {
  LINUX = 'Linux',
  WINDOWS = 'Windows',
  MACOS = 'MacOS',
  TO_BE_DEFINED = 'To be defined',
  ANY_OS = 'Any OS',
}
